interface LockedFieldProps {
  label: string;
  value: string;
  hint?: string;
  actionLabel?: string;
  onAction?: () => void;
}

function LockIcon() {
  return (
    <svg
      className="lock-icon"
      viewBox="0 0 14 16"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M11 6V5a4 4 0 00-8 0v1H1v9h12V6h-2zm-6-1a2 2 0 014 0v1H5V5zm6 8H3V8h8v5z" />
    </svg>
  );
}

export function LockedField({
  actionLabel,
  label,
  onAction,
  value,
  hint,
}: LockedFieldProps) {
  return (
    <div className="field-locked">
      <label>
        <LockIcon />
        {label}
      </label>
      <div className="locked-value">
        <span>{value || "–"}</span>
        <span className="locked-badge">
          {actionLabel && onAction ? (
            <button className="locked-action" onClick={onAction} type="button">
              {actionLabel}
            </button>
          ) : (
            "Locked"
          )}
        </span>
      </div>
      {hint && <div className="hint">{hint}</div>}
    </div>
  );
}
